import { generatePath } from 'react-router-dom';
import { BaseQueryParams } from 'common/models';
import { Paginated } from 'common/utils';
import apiPaths from 'config/apiPaths';

import { PublicFile } from '../common/models/file';
import { buildBasicPaginatedSearchParams } from '../common/utils/searchParams.helper';
import { CreateNewsNewRequest } from '../modules/NewsNew/models/create-news-new-request';
import { NewsNewResponse } from '../modules/NewsNew/models/news-new-response';
import { UpdateNewsNewRequest } from '../modules/NewsNew/models/update-news-new-request';
import { createFormData } from './api-utils';
import axiosInstance from './axios';

export const getNewsNewList = async ({
  searchText,
  page,
  limit,
}: BaseQueryParams): Promise<Paginated<NewsNewResponse>> => {
  const searchParams = buildBasicPaginatedSearchParams(page, limit, searchText);
  const { data } = await axiosInstance.get<Paginated<NewsNewResponse>>(apiPaths.NEWS_NEW, { params: searchParams });
  return data;
};

export const getNewsNew = async (id: string): Promise<NewsNewResponse> => {
  const { data } = await axiosInstance.get<NewsNewResponse>(generatePath(apiPaths.NEWS_NEW_ARTICLE, { newsId: id }));
  return data;
};

export const createNewsNew = (request: CreateNewsNewRequest): Promise<NewsNewResponse> => {
  const data = createFormData(request);
  return axiosInstance.post(apiPaths.NEWS_NEW, data);
};

export const updateNewsNew = (id: string, request: UpdateNewsNewRequest): Promise<NewsNewResponse> => {
  const data = createFormData(request);
  return axiosInstance.put(generatePath(apiPaths.NEWS_NEW_ARTICLE, { newsId: id }), data);
};

export const deleteNewsNew = (id: string): Promise<void> => {
  return axiosInstance.delete(generatePath(apiPaths.NEWS_NEW_ARTICLE, { newsId: id }));
};

export const uploadFile = async (image: File): Promise<PublicFile> => {
  const formData = createFormData({ image });
  return axiosInstance
    .post(apiPaths.NEWS_NEW_IMAGES, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(({ data }) => data);
};
